import InitializeGroupRecord from "models/view-models/group-invitations/initialize-group-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------

export interface InitializeGroupResourcePathParams {
    groupId: number;
}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "groups";
const resourceType = InitializeGroupRecord;
const resourceEndpoint = `${baseEndpoint}/:groupId`;
const initializeEndpoint = `${resourceEndpoint}/initialize`;
const key = "groups";

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const InitializeGroupService = {
    key,
    /**
     * Initialize a group
     */
    initialize: ServiceFactory.update<
        InitializeGroupRecord,
        InitializeGroupResourcePathParams
    >(resourceType, initializeEndpoint),

    /**
     * Custom hook for leveraging service initialize calls in react components
     */
    useInitialize: ServiceHookFactory.useUpdate<
        InitializeGroupRecord,
        InitializeGroupResourcePathParams
    >(resourceType, initializeEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default InitializeGroupService;
